(function($){
    var $fn = $(".comp_courses");

    $fn.on("click", "[data-changecourses]", function(e) {
        e.preventDefault();

        $.ajax({
            method: "GET",
            url: $(this).attr("href")
        });
    });

    var $slider = $fn.find("[data-slider]"),
        $autoplay = ($slider.attr("data-autoplay")),
        $autoplay_speed = ($autoplay)?$slider.data("autoplay"):0;

    if ($slider.children().length > 4) {
        $slider.slick({
            infinite: true,
            speed: 500,
            fade: false,
            focusOnSelect: false,
            slidesToShow: 4,
            cssEase: 'linear',
            autoplay: $autoplay,
            autoplaySpeed: $autoplay_speed,
            arrows: true,
            prevArrow: "<a class='slick-prev slick-arrow icon--chevron-left'></a>",
            nextArrow: "<a class='slick-next slick-arrow icon--chevron-right'></a>",
            pauseOnHover: false,
            dots: false,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
})(jQuery);